<br>
<div class="container header">
  <h3 class="header__title">User Sampling</h3>
  <form-factory class="input-switch input-switch--inline" [formGroup]="userSamplingSwitchGroup"
    [model]="userSamplingActiveSwitch" (onChange)="onUserSamplingSwitchChange($event)"></form-factory>
</div>
<p>
  Sets a fixed Overread-I review rate for an abstractor, added on top of Project and Measure Sampling. Not counted against the project target.
</p>
<div *ngIf="userSamplingEnabled" class="user-sampling-table">
  <table class="table">
    <tr>
      <td>Full Name</td>
      <td>Sampling Type</td>
      <td>Sampling Count</td>
      <td></td>
    </tr>
    <ng-container *ngFor="let group of userRowGroup; let i = index; trackBy: trackByIndex">
      <tr>
        <ng-container *ngFor="let row of getControls(group.formGroup); let j = index; trackBy: trackByIndex">
          <td style="padding: 0.25rem">
            <form-factory class="input" [formGroup]="group.formGroup" [model]="group.userModels[j]">
            </form-factory>
          </td>
        </ng-container>
        <td>
          <div *ngIf="canDeleteRow(group)" class="action-button">
            <app-icon (click)="deleteRow(i)" iconName="fa-regular fa-trash"></app-icon>
          </div>
        </td>
      </tr>
    </ng-container>
  </table>
  <div class="container flex-gap add-measure-row">
    <div class="container flex-gap add-measure" (click)="addNewRow()">
      <app-icon iconName="plus-circle" iconStyle="far"></app-icon>
      <span>Add Users</span>
    </div>
  </div>
</div>